'use es6';

import { Component } from 'react';
import SlackAPI from '../utils/SlackAPI';
import { H2 } from 'foundations-components/transitional/components/H2';
import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { Section } from 'foundations-components/transitional/components/Section';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { H5 } from 'foundations-components/transitional/components/H5';
import Alerts from '../utils/alerts';
import SlackChannelSelect from '../components/SlackChannelSelect';
import SlackResponseStatusDeterminer from '../utils/SlackResponseStatusDeterminer';
import FailedToLoadChannelsBanner from './FailedToLoadChannelsBanner';
import { UsageTracker } from '../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_ALERTS = 'slackUiLibrary.shareToSlackSidePanel.alerts';
class ShareToSlackPanel extends Component {
  constructor(props) {
    super(props);
    this.updateSelectedChannel = selectedChannelId => this.setState({
      selectedChannelId
    });
    this.updateMessage = evt => this.setState({
      message: evt.target.value
    });
    this.processSharingResult = response => {
      if (SlackResponseStatusDeterminer.isErrorResponse(response)) {
        this.handleSharingError(response);
        return;
      }
      this.setState({
        isSharing: false,
        sharingFailed: false
      });
      Alerts.displaySuccessSharingAlert(response['@ok']);
      this.props.closePanel();
    };
    this.share = () => {
      this.setState({
        isSharing: true
      });
      SlackAPI.shareToSlack(this.props.recordToShare, this.state.selectedChannelId, this.state.message).then(this.processSharingResult).catch(() => this.handleSharingError());
      UsageTracker.track('record-shared-to-slack', {
        recordId: this.props.recordToShare.id,
        recordType: this.props.recordToShare.type,
        slackChannelId: this.state.selectedChannelId,
        placeIdentifier: this.props.placeIdentifier
      });
    };
    this.setSlackOutageStatus = status => {
      this.setState({
        isSlackOutage: status
      });
    };
    this.state = {
      isSharing: false,
      sharingFailed: false,
      selectedChannelId: undefined,
      message: undefined,
      isSlackOutage: false
    };
  }
  handleSharingError(error) {
    this.setState({
      sharingFailed: true,
      isSharing: false
    });
    let errorId;
    let title;
    let message;
    if (SlackResponseStatusDeterminer.isInvalidAuthError(error)) {
      errorId = `authError`;
      title = `${I18N_ALERTS}.general.invalidAuth.title`;
      message = `${I18N_ALERTS}.general.invalidAuth.message`;
    } else if (SlackResponseStatusDeterminer.isThirdPartyOutageError(error)) {
      errorId = `slackOutageError`;
      title = `${I18N_ALERTS}.messageSharing.error.slackOutage.title`;
      message = `${I18N_ALERTS}.messageSharing.error.slackOutage.message`;
    } else {
      errorId = `defaultSharingError`;
      title = `${I18N_ALERTS}.messageSharing.error.general.title`;
      message = `${I18N_ALERTS}.messageSharing.error.general.message`;
    }
    Alerts.displayErrorAlert(errorId, title, message);
  }
  renderBody() {
    return /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsxs(Section, {
        children: [/*#__PURE__*/_jsx(H5, {
          children: this.props.description.header
        }), /*#__PURE__*/_jsx(FailedToLoadChannelsBanner, {
          shouldShow: this.state.isSlackOutage
        }), this.props.description.body]
      }), /*#__PURE__*/_jsx(FormControl, {
        error: this.state.isSlackOutage,
        validationMessage: this.state.isSlackOutage && /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_ALERTS}.channelsFetching.error.failedToLoadChannels.contextualMessage`
        }),
        children: /*#__PURE__*/_jsx(SlackChannelSelect, {
          disabled: this.state.isSharing,
          onChange: this.updateSelectedChannel,
          setSlackOutageStatus: this.setSlackOutageStatus
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        children: /*#__PURE__*/_jsx(TextArea, {
          padding: "1600",
          paddingInline: "250",
          paddingBlockStart: "250",
          onChange: this.updateMessage,
          disabled: this.state.isSharing,
          placeholder: I18n.text('slackUiLibrary.shareToSlackSidePanel.message.placeholder')
        })
      })]
    });
  }
  renderFooter() {
    return /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_ALERTS}.channelsFetching.error.failedToLoadChannels.buttonTip`
        }),
        disabled: !this.state.isSlackOutage,
        children: /*#__PURE__*/_jsx(LoadingButton, {
          type: "submit",
          use: "primary",
          loading: this.state.isSharing,
          failed: this.state.sharingFailed,
          onClick: this.share,
          disabled: !this.state.selectedChannelId,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "slackUiLibrary.shareToSlackButton.text"
          })
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: this.props.closePanel,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "slackUiLibrary.shareToSlackSidePanel.cancel"
        })
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx(ModalPanel, {
      width: 500,
      children: /*#__PURE__*/_jsxs(Form, {
        children: [/*#__PURE__*/_jsxs(DialogHeader, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "slackUiLibrary.shareToSlackButton.text"
            })
          }), /*#__PURE__*/_jsx(DialogCloseButton, {
            onClick: this.props.closePanel
          })]
        }), this.renderBody(), this.renderFooter()]
      })
    });
  }
}
ShareToSlackPanel.propTypes = {
  closePanel: PropTypes.func,
  recordToShare: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  description: PropTypes.shape({
    header: PropTypes.string.isRequired,
    body: PropTypes.string
  }),
  placeIdentifier: PropTypes.string
};
export default ShareToSlackPanel;